export interface Country {
    id: string;
    name: string;
}

export function createCountries(list: { countryid: string; countryname: string }[]): Country[] {
    return list.map(({ countryid, countryname }) => ({ id: countryid, name: countryname }));
}
